import React from "react";
import BillingPolicyBuilderConstants from "./constants/BillingPolicyBuilderConstants";
import BillingPolicyBuilderWorkspace from "./BillingPolicyBuilderWorkspace";
import BillingPolicyBuilderErrors from "./BillingPolicyBuilderErrors";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import ModalDuplicateConfirmation from "../ModalWarning/ModalDuplicateConfirmation";

class BillingPolicyBuilder extends React.Component {
  constructor(props) {
    super(props);

    var self = this;

    if (this.props.read_only) {
      this.buttons = [
        {
          name: I18n.t("ok"),
          html_attributes: ['data-dismiss="modal"'],
        },
      ];
    } else {
      this.buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: function (e) {
            e.stopPropagation();
            e.preventDefault();

            self.onSave();
          },
        },
      ];
    }

    this.rules = {
      reservation_created: [
        BillingPolicyBuilderConstants.IMMEDIATELY,
        BillingPolicyBuilderConstants.AFTER,
      ],
      check_in_date: [
        BillingPolicyBuilderConstants.IMMEDIATELY,
        BillingPolicyBuilderConstants.BEFORE,
        BillingPolicyBuilderConstants.AFTER,
      ],
      check_out_date: [
        BillingPolicyBuilderConstants.IMMEDIATELY,
        BillingPolicyBuilderConstants.BEFORE,
        BillingPolicyBuilderConstants.AFTER,
      ],
    };

    this.state = this.getState();
    this.onSave = this.onSave.bind(this);
    this.onAddCancellationRule = this.onAddCancellationRule.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeRate = this.onChangeRate.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeCancellationRule = this.onChangeCancellationRule.bind(this);
    this.onRemoveCancellationRule = this.onRemoveCancellationRule.bind(this);
    this.onSelectAllNoneRates = this.onSelectAllNoneRates.bind(this);
    this.generateId = this.generateId.bind(this);
    this.onChangeCancellationRules = this.onChangeCancellationRules.bind(this);
    this.onChangePercent = this.onChangePercent.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangeDepositDays = this.onChangeDepositDays.bind(this);
    this.onChangeCollectReservationDeposit =
      this.onChangeCollectReservationDeposit.bind(this);
    this.onChangeRefundable = this.onChangeRefundable.bind(this);
    this.onChangeRefundableUntilTime =
      this.onChangeRefundableUntilTime.bind(this);
  }

  getState() {
    if (
      this.props.cancellation_rules &&
      this.props.cancellation_rules.length > 0
    ) {
      var cancellation_rule_ids = this.props.cancellation_rules.map(
        (rule) => rule.id
      );
    } else {
      var cancellation_rule_ids = [];
    }
    var capture_balance_value = this.props.capture_balance_time_value || this.props.capture_balance_time_value == 0 ? this.props.capture_balance_time_value : ''
    return {
      active_tab: "general",

      capture_balance_lifecycle_event:
        this.props.capture_balance_lifecycle_event || "check_out_date",
      capture_balance_time_period:
        this.props.capture_balance_time_period || "immediately",
      capture_balance_time_value: capture_balance_value,

      cancellation_rule_ids: cancellation_rule_ids,
      cancellation_rules: this.props.cancellation_rules,
      all_cancellation_rules: this.props.all_cancellation_rules,
      collect_reservation_deposit: this.props.collect_reservation_deposit,

      refundable: this.props.refundable,
      refundable_until_days: this.props.refundable_until_days,
      refundable_until_time: this.props.refundable_until_time
        ? new Date(this.props.refundable_until_time)
        : null,
      refundable_penalty_percentage: this.props.refundable_penalty_percentage,

      deposit_amount: this.props.deposit_amount || "",
      deposit_days: this.props.deposit_days || "",
      deposit_lifecycle_event: this.props.deposit_lifecycle_event,
      deposit_percentage: this.props.deposit_percentage || "",
      deposit_time_period: this.props.deposit_time_period,
      deposit_time_value: this.props.deposit_time_value || "",

      rate_ids: this.props.rate_ids || [],
      rates: this.props.rates,
      status: this.props.status || null,
      duplication_warnings: [],
      duplicate_confirmation: false,
      errors: this.props.errors || [],
      loading: this.props.loading || false,
      id: this.props.id,
      name: this.props.name || "",
      code: this.props.code || "",
      terms: this.props.terms || "",
      read_only: this.props.read_only,
    };
  }

  componentDidUpdate(prevprops) {
    if (prevprops.errors !== this.props.errors) {
      this.setState({ errors: this.props.errors });
    }
  }

  componentDidMount() {
    var self = this;
    $(window).on("billingPolicySaved", function () {
      $.ajax({
        type: "POST",
        url: `/admin/billing_policies/${self.props.id}/data`,
      }).done((data) => {
        self.setState({ ...data });
      });
    });
  }

  /*******************
   * Render functions *
   ********************/

  render() {
    return (
      <div className="billing-policy-builder" ref="root">
        <div className="panel panel-form">
          {this.props.hideModalButtons === true ? null : (
            <ModalButtons loading={this.state.loading} buttons={this.buttons} />
          )}
          {this.props.hideModalButtons === true ? null : (
            <Tabs
              tabs={this.tabs()}
              displayErrorMessage={
                BillingPolicyBuilderErrors.general(this.state.errors).length ||
                  BillingPolicyBuilderErrors.rates(this.state.errors).length ||
                  BillingPolicyBuilderErrors.cancellation_rules(this.state.errors)
                    .length
                  ? true
                  : false
              }
            />
          )}
          <BillingPolicyBuilderWorkspace
            {...this.props}
            {...this.state}
            rules={this.rules}
            onChange={this.onChange}
            onChangeCollectReservationDeposit={
              this.onChangeCollectReservationDeposit
            }
            onChangeRefundable={this.onChangeRefundable}
            onChangeRefundableUntilTime={this.onChangeRefundableUntilTime}
            onChangeRate={this.onChangeRate}
            onAddCancellationRule={this.onAddCancellationRule}
            onChangeCancellationRule={this.onChangeCancellationRule}
            onRemoveCancellationRule={this.onRemoveCancellationRule}
            onSelectAllNoneRates={this.onSelectAllNoneRates}
            onChangeRoomType={this.onChangeRoomType}
            onChangeSeasonalPrices={this.onChangeSeasonalPrices}
            generateId={this.generateId}
            onChangeCancellationRules={this.onChangeCancellationRules}
            onChangePercent={this.onChangePercent}
            onChangeAmount={this.onChangeAmount}
            onChangeDepositDays={this.onChangeDepositDays}
          />
          <LoadingSpinner show={this.state.loading} />
        </div>

        <ModalDuplicateConfirmation
          onConfirm={() => {
            this.setState(
              { duplication_warnings: [], duplicate_confirmation: true },
              () => {
                this.onSave();
              }
            );
          }}
          onClose={() => {
            this.setState({ duplication_warnings: [] });
          }}
          duplication_warnings={this.state.duplication_warnings}
        />
      </div>
    );
  }

  /******************
   * Change handlers *
   *******************/

  onAddCancellationRule() {
    var cancellation_rules = this.state.cancellation_rules.slice(0);

    cancellation_rules.unshift({
      id: this.generateId(),
    });

    this.setState({ cancellation_rules: cancellation_rules });
  }

  onChange(name, event) {
    this.state[name] =
      event && event.target && typeof event.target.value !== "undefined"
        ? event.target.value
        : event;
    this.forceUpdate(() => {
      if (typeof this.props.onChange == "function") {
        this.props.onChange(this.state);
      }
    });
  }

  onChangePercent(value) {
    if (value) {
      var state = this.state;
      state.deposit_amount = null;
      state.deposit_percentage = value;
      state.deposit_days = null;
      this.setState(state);
    }
  }

  onChangeAmount(value) {
    if (value) {
      var state = this.state;
      state.deposit_amount = value;
      state.deposit_percentage = null;
      state.deposit_days = null;
      this.setState(state);
    }
  }

  onChangeDepositDays(e) {
    if (e) {
      var state = this.state;
      state.deposit_amount = null;
      state.deposit_percentage = null;
      state.deposit_days = e.target.value;
      this.setState(state);
    }
  }

  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  }

  onChangeCancellationRules(selected_rules) {
    
    this.setState({
      cancellation_rule_ids: selected_rules,
    });
  }

  onChangeCancellationRule(cancellation_rule) {
    var cancellation_rules = this.state.cancellation_rules.slice(0);
    var index = this.getCancellationRuleIndex(cancellation_rule.id);

    cancellation_rules[index] = cancellation_rule;
    this.setState({ cancellation_rules: cancellation_rules });
  }

  onChangeRate(rates) {
    this.setState({ rate_ids: rates });
  }

  onRemoveCancellationRule(id) {
    var cancellation_rules = this.state.cancellation_rules.slice(0);
    var index = this.getCancellationRuleIndex(id);

    cancellation_rules[index]["_destroy"] = true;

    this.setState({ cancellation_rules: cancellation_rules });
  }

  onSave() {
    this.setState({ loading: true });

    $.ajax({
      type: this.props.new_record ? "POST" : "PUT",
      url: this.props.form_action,
      data: {
        billing_policy: {
          capture_balance_lifecycle_event:
            this.state.capture_balance_lifecycle_event,
          capture_balance_time_period: this.state.capture_balance_time_period,
          capture_balance_time_value: this.state.capture_balance_time_value,
          collect_reservation_deposit: this.state.collect_reservation_deposit,
          deposit_amount:
            this.state.deposit_amount && this.state.deposit_amount > 0
              ? this.state.deposit_amount
              : null,
          deposit_days:
            this.state.deposit_days && this.state.deposit_days > 0
              ? this.state.deposit_days
              : null,
          deposit_lifecycle_event: this.state.deposit_lifecycle_event,
          deposit_percentage:
            this.state.deposit_percentage && this.state.deposit_percentage > 0
              ? this.state.deposit_percentage
              : null,
          deposit_time_period: this.state.deposit_time_period,
          deposit_time_value: this.state.deposit_time_value,
          name: this.state.name,
          code: this.state.code,
          terms: this.state.terms,
          rate_ids: this.state.rate_ids,
          cancellation_rule_ids: this.state.cancellation_rule_ids,
  
        },
      },
    }).done((data) => {

        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          if (this.props.new_record == true) {
            parent.refresh_data(I18n.t("billing_policy_created_successfully"));
          } else {
            parent.refresh_data(I18n.t("billing_policy_saved_successfully"));
          }
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({
          errors: data.responseJSON,
          loading: false,
        });
        $(".modal-body").scrollTop(0);
      }
    });
  }

  onSelectAllNoneRates(event) {
    if (event.target.checked) {
      var rate_ids = this.props.all_rates.map(function (rate) {
        if (rate && rate.id) {
          return rate.id;
        }
      });
    } else {
      var rate_ids = [];
    }
    this.setState({ rate_ids: rate_ids });
  }

  onChangeCollectReservationDeposit(event) {
    this.setState({
      collect_reservation_deposit: event.target.checked,
      deposit_amount: null,
      deposit_percentage: null,
      deposit_days: null
    });
  };

  onChangeRefundable(event) {
    this.setState({ refundable: event.target.checked });
  }

  onChangeRefundableUntilTime(time) {
    this.setState({
      refundable_until_time: time,
    });
  }

  /*******************
   * Helper functions *
   ********************/

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }

  getCancellationRuleId(idstring) {
    var myregexp = /\[(.*?)\]/;
    var match = myregexp.exec(idstring);

    if (match && match.length >= 2) {
      return match[1];
    }
  }

  getCancellationRule(id) {
    for (
      var i = 0, ilen = this.state.cancellation_rules.length;
      i < ilen;
      i++
    ) {
      if (this.state.cancellation_rules[i].id == id) {
        return this.state.cancellation_rules[i];
      }
    }
  }

  getCancellationRuleIndex(id) {
    for (
      var i = 0, ilen = this.state.cancellation_rules.length;
      i < ilen;
      i++
    ) {
      if (this.state.cancellation_rules[i].id == id) {
        return i;
      }
    }
  }

  tabs() {
    if (this.props.read_only && this.props.history_hidden != true) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("rates"),
          targetName: "rates",
          classes: this.state.active_tab === "rates" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("cancellation_rules"),
          targetName: "cancellation_rules",
          classes:
            this.state.active_tab === "cancellation_rules" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("history"),
          targetName: "history",
          classes: this.state.active_tab === "history" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
    } else {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: BillingPolicyBuilderErrors.general(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("rates"),
          targetName: "rates",
          classes: this.state.active_tab === "rates" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: BillingPolicyBuilderErrors.rates(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("cancellation_rules"),
          targetName: "cancellation_rules",
          classes:
            this.state.active_tab === "cancellation_rules" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: BillingPolicyBuilderErrors.cancellation_rules(
            this.state.errors
          ).length,
        },
      ];
    }
  }
}

export default BillingPolicyBuilder;